import React, { useState, useEffect } from 'react';

const TawkChat = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [isChatOpen, setIsChatOpen] = useState(false);
  
  // Prevenir scroll cuando el chat está abierto
  useEffect(() => {
    // Ya no necesitamos bloquear el scroll
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isChatOpen]);

  const toggleChat = (e) => {
    e.preventDefault();
    setIsChatOpen(!isChatOpen);
  };
  
  return (
    <>
      {/* Botón de chat flotante */}
      <button
        onClick={toggleChat}
        style={{
          position: 'fixed',
          bottom: '30px',
          right: '30px',
          backgroundColor: isHovered ? '#0077DD' : '#0066CC',
          color: 'white',
          borderRadius: '50%',
          width: '65px',
          height: '65px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          boxShadow: isHovered ? '0 4px 15px rgba(0,102,204,0.4)' : '0 2px 10px rgba(0,0,0,0.2)',
          cursor: 'pointer',
          zIndex: 9999,
          transition: 'all 0.3s ease',
          border: 'none',
          // Ocultamos el botón cuando el chat está abierto
          display: isChatOpen ? 'none' : 'flex'
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        aria-label="Chatear con soporte"
      >
        {/* Icono de chat */}
        <div style={{ position: 'relative' }}>
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width="28" 
            height="28" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
            style={{ marginBottom: '2px' }}
          >
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
          </svg>
          
          {/* Texto emergente con animación */}
          <div 
            style={{
              position: 'absolute',
              right: '80px',
              top: '50%',
              transform: `translateY(-50%) scale(${isHovered ? '1' : '0.8'})`,
              opacity: isHovered ? 1 : 0,
              backgroundColor: 'white',
              color: '#333',
              padding: '8px 12px',
              borderRadius: '4px',
              boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
              whiteSpace: 'nowrap',
              transition: 'all 0.3s ease',
              pointerEvents: 'none'
            }}
          >
            Chatear con soporte
          </div>
        </div>
      </button>

      {/* Chat en la esquina */}
      {isChatOpen && (
        <div style={{
          position: 'fixed',
          bottom: '30px',
          right: '30px',
          width: '350px',
          height: '700px',
          boxShadow: '0 10px 30px rgba(0,0,0,0.3)',
          borderRadius: '8px',
          overflow: 'hidden',
          zIndex: 10000,
          animation: 'fadeIn 0.3s'
        }}>
          <div style={{
            position: 'relative',
            width: '100%',
            height: '100%',
            backgroundColor: 'white',
            overflow: 'hidden'
          }}>
            {/* Header personalizado de Ecosoft */}
            <div style={{
              backgroundColor: '#0066CC',
              color: 'white',
              padding: '12px 15px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              borderBottom: '1px solid rgba(255,255,255,0.1)'
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center'
              }}>
                <img 
                  src="/images/Logo.png" 
                  alt="ECOSOFT" 
                  style={{
                    height: '24px',
                    width: 'auto',
                    marginRight: '10px'
                  }}
                />
                <span style={{
                  fontWeight: 'bold',
                  fontSize: '16px'
                }}>ECOSOFT</span>
              </div>
              
              {/* Botón para cerrar el chat */}
              <button 
                onClick={toggleChat}
                style={{
                  backgroundColor: 'rgba(255,255,255,0.2)',
                  border: 'none',
                  color: 'white',
                  width: '28px',
                  height: '28px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderRadius: '50%',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(255,255,255,0.3)'}
                onMouseLeave={(e) => e.target.style.backgroundColor = 'rgba(255,255,255,0.2)'}
              >
                ×
              </button>
            </div>
            
            {/* iframe de Tawk.to */}
            <iframe
              src="https://tawk.to/chat/57e964a24a427d157425520a/default"
              style={{
                width: '100%',
                height: 'calc(100% - 48px)',
                border: 'none'
              }}
              title="Chat de soporte"
            ></iframe>
          </div>
        </div>
      )}

      {/* Estilos para la animación */}
      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}
      </style>
    </>
  );
};

export default TawkChat; 